export const subscriptionsApiSelector = state => state.api.subscriptions;
